import type { FaireProductEntity } from "../../entity_types/product";

export const p_a7727vbm2c: FaireProductEntity = {
  token: "p_a7727vbm2c",
  type: "product",
  name: "Deep Mercy Snoozer",
  brandToken: "b_fnw2e7p4xp",
  brandName: "BRVE by Fletch",
  imageUrl:
    "https://cdn.faire.com/fastly/6e9e5031b2efb2b12255a2ffa088ca678bb203afb561efcfc4dde7b586184777.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86b1841e118f103ffd91c875f7425c39c50cede7606ddceb7b42ed35fa7dffe0.jpeg",
    "https://cdn.faire.com/fastly/d7e70154db3d19d43db9d16bfe397db84a08a9cd7633658c6d63f6c69d978e5e.jpeg",
    "https://cdn.faire.com/fastly/9c1f87f3dcf3177dad95ef132e6b58ec617bc44f590f21db9f192c1656c71a53.jpeg",
    "https://cdn.faire.com/fastly/c578c89657e17a019dcff87ce77ea1525d21e88f6b3da3e392bc75a245692c0b.jpeg",
    "https://cdn.faire.com/fastly/ad1bc889c2ffaadd28b47b2bfc62d1b5665c2a47d828a935e4f2df7086897b85.jpeg",
  ],
  priceDollars: 22.8,
  description:
    "Description:\n\n\nSettle in, little dreamer. Our Snoozer is designed for rest, comfort, and peace—because bedtime should be a safe space where kids feel wrapped in love. Made with buttery-soft bamboo blend fabric, this Snoozer keeps your child cozy and cool through the night.\n\nBut it’s more than pajamas—it’s discipleship by design. Every BRVE print carries a message of courage, faith, and identity in Christ, giving families simple ways to plant seeds of truth in the hearts of their kids. Night after night, these PJs become part of a rhythm of reminding children who they are and whose they are.\n\n * \n95% viscose from bamboo, 5% spandex for stretch and softness\n\n * \nBreathable and temperature-regulating for year-round comfort\n\n * \nExclusive, hand-drawn prints that carry BRVE’s signature message of courage and faith\n",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:57.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
